import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

export function ExampleReportCTA({ onExampleLoad, isLoading }) {
    const { t } = useTranslation();

    return (
        <button
            onClick={onExampleLoad}
            disabled={isLoading}
            className="w-full flex items-center justify-center px-4 py-2.5 
                text-sm font-medium rounded-lg text-orange-600 bg-orange-50/50 
                hover:bg-orange-100 hover:text-orange-700
                transition-all duration-200 transform hover:-translate-y-0.5
                border border-orange-100 hover:border-orange-200
                group disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <span className="flex items-center">
                {isLoading ? (
                    <>
                        <svg 
                            className="animate-spin -ml-1 mr-2 h-4 w-4 text-orange-500" 
                            xmlns="http://www.w3.org/2000/svg" 
                            fill="none" 
                            viewBox="0 0 24 24"
                        >
                            <circle 
                                className="opacity-25" 
                                cx="12" 
                                cy="12" 
                                r="10" 
                                stroke="currentColor" 
                                strokeWidth="4"
                            />
                            <path 
                                className="opacity-75" 
                                fill="currentColor" 
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                        </svg>
                        {t('upload.processing')}
                    </>
                ) : (
                    <>
                        <svg 
                            className="w-4 h-4 mr-2 text-orange-500 group-hover:scale-110 transition-transform" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth="2" 
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                            />
                        </svg>
                        {t('upload.tryExample')}
                    </>
                )}
            </span>
        </button>
    );
} 